<template>
  <TranslationDisplay
    class="lift-description"
    :class="{'lift-description--no-bottom-space': noBottomSpace}"
    :translation="lift.excerpt"
    html
  />
</template>

<script>
import Vue from 'vue'
import TranslationDisplay from '../../base/Translation/TranslationDisplay.vue'

export default Vue.extend({
  name: 'LiftDescription',
  components: { TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    },
    noBottomSpace: Boolean
  }
})
</script>

<style
  lang="scss"
>
.lift-description {
  &--no-bottom-space {
    > *:last-child {
      margin-bottom: 0;
    }
  }
}

</style>